import { Select as SelectMui, SelectProps as SelectPropsMui } from '@mui/material';

export type SelectProps = SelectPropsMui;

export const Select = SelectMui;
